import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Main from '../../layout/main';
import { login } from '../../redux/actions/login';
import NavTabs from "../../components/tabs/tabs";
import { Container, Row, Col } from "reactstrap";
import { connect } from 'react-redux';
class FirstPage extends Component {
    state = {
        status: true,
        email: "",
        password: "",
    }

    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EasyBids - Home Improvements :: Login </title>
                    <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
                </Helmet>
                <Main  >
                    <section className="ebw-section__pages">
                        <Container>
                            <Row>
                                <Col sm="12" md="10" lg="6" className="mx-auto text-center">
                                    <div className="ebw-entry__content-rgt position-relative" style={{
                                        backgroundColor: 'white',
                                        border: '1px solid #e5e5e5',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        padding: '30px',
                                        borderRadius: '8px',
                                        height: 'auto'
                                    }}>
                                        <div
                                            className="ebw-entry__register-flow position-relative d-flex flex-column mx-auto justify-content-center">
                                            <h2 className="ebw-entry__title">
                                                <div className="ebw-entry__title-top">Login</div>
                                                <div className="ebw-entry__title-bottom mb-3">to your account to
                                                    continue
                                                </div>
                                            </h2>
                                            <NavTabs/>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Main>
            </div>
                        );
                    }
}

const mapStateToProps = state => ({
    auth: state.login
});
export default connect(mapStateToProps, {
    login
})(FirstPage);